import { render, staticRenderFns } from "./UpdatePasswordView.vue?vue&type=template&id=5aff2f2b&scoped=true&"
import script from "./UpdatePasswordView.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordView.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePasswordView.vue?vue&type=style&index=0&id=5aff2f2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aff2f2b",
  null
  
)

export default component.exports